import { CSSProperties } from "react";
import { theme } from "antd";

export const TableIcon = (props: {
  style?: CSSProperties;
  size?: number;
  inactive?: boolean;
}) => {
  const { token } = theme.useToken();
  const size = props.size ?? 16;
  const color = props.inactive ? token.colorTextSecondary : token.colorText;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 15"
      fill="none"
      style={{ display: "block", ...props.style }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={props.inactive ? "0.5" : "0.9"}>
        <rect
          width="18.5625"
          height="0.5"
          transform="translate(0.751831 0.75)"
          fill={color}
        />
        <rect
          width="18.5625"
          height="2"
          transform="translate(0.751831 4.52083)"
          fill={color}
        />
        <rect
          width="18.5625"
          height="0.5"
          transform="translate(0.751831 9.79167)"
          fill={color}
        />
        <rect
          width="18.5625"
          height="0.5"
          transform="translate(0.751831 13.5625)"
          fill={color}
        />
        <rect
          width="0.5"
          height="13.3125"
          transform="translate(0.751831 0.75)"
          fill={color}
        />
        <rect
          width="2"
          height="13.3125"
          transform="translate(6.27271 0.75)"
          fill={color}
        />
        <rect
          width="0.5"
          height="13.3125"
          transform="translate(13.2935 0.75)"
          fill={color}
        />
        <rect
          width="0.5"
          height="13.3125"
          transform="translate(18.8143 0.75)"
          fill={color}
        />
      </g>
    </svg>
  );
};
